'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Image from 'next/image';
import { useClosetAuth } from '@/contexts/ClosetAuthContext';
import { updateLookMedia } from '@/lib/closet/api-client';
import type { Outfit } from '@/types/closet';
import { Button } from './Button';
import { Overlay } from './Overlay';
import { OutfitGallery } from './OutfitGallery';
async function runUpdate(outfit: Outfit, action: 'image' | 'rotation' | 'accept' | 'discard') {
  try {
    return {
      outfit: await updateLookMedia(outfit.id, action, outfit.mediaCandidate?.id),
      error: ''
    };
  } catch (error) {
    return {
      outfit: null,
      error: error instanceof Error ? error.message : 'Could not update this look'
    };
  }
}
export function MediaReview(t0) {
  const $ = _c(13);
  const {
    outfit,
    onUpdate
  } = t0;
  const {
    isAuthenticated
  } = useClosetAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const candidate = outfit.mediaCandidate;
  let t1;
  if ($[0] !== onUpdate || $[1] !== outfit) {
    t1 = async function update(action) {
      setBusy(true);
      setError("");
      const result = await runUpdate(outfit, action);
      if (result.outfit) {
        onUpdate(result.outfit);
      }
      setError(result.error);
      setBusy(false);
    };
    $[0] = onUpdate;
    $[1] = outfit;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const update = t1;
  if (!isAuthenticated) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button aria-label="Edit outfit media" onClick={() => setOpen(true)}>↗</Button>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== busy || $[5] !== candidate || $[6] !== error || $[7] !== open || $[8] !== outfit || $[9] !== update) {
    t3 = open && <Overlay label="Review look media" onClose={() => {
      if (!busy) {
        setOpen(false);
      }
    }}><h2>Review look media</h2><div className="lookbook-media-comparison"><div><p>Current look</p>{outfit.imageUrl && <Image unoptimized={true} src={outfit.lookbookMedia?.imageUrl || outfit.imageUrl} alt="Current look" width={400} height={600} />}</div><div><p>Candidate</p>{candidate ? <div className="lookbook-candidate-gallery"><OutfitGallery outfit={{
              ...outfit,
              lookbookMedia: candidate
            }} /></div> : <p>Generate a new image to compare.</p>}</div></div><div className="lookbook-review-actions"><Button disabled={busy} onClick={() => update("image")}>{busy ? "Working\u2026" : "Generate image"}</Button>{candidate && <Button disabled={busy} onClick={() => update("rotation")}>Prepare rotation</Button>}{candidate?.status === "ready" && <Button disabled={busy} onClick={() => update("accept")}>Use this look</Button>}{candidate && <Button disabled={busy} onClick={() => update("discard")}>Discard candidate</Button>}</div><p role="status">{error || (busy ? "This can take a few minutes. Your current look stays available." : "Review the garments and the full turn before using this look.")}</p></Overlay>;
    $[4] = busy;
    $[5] = candidate;
    $[6] = error;
    $[7] = open;
    $[8] = outfit;
    $[9] = update;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}